'use client';

import Badge from '@/components/ui/Badge/Badge';
import ToggleIconButton from '@/components/ui/ToggleIconButton/ToggleIconButton';
import { useIsMenuOpenedAtom } from '@monorepo/common';
import type { Session } from 'next-auth';
import { useSession } from 'next-auth/react';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import ActionButton from '../../form/ActionButton/ActionButton';
import styles from './FamikujiHeader.module.scss';

function FamikujiHeader({
  initialSessionData,
  isOptionNotEntered = false,
  hasPendingEntry = false,
  hasAlertEcItem = false,
}: {
  initialSessionData?: ReturnType<typeof useSession>['data'];
  isOptionNotEntered?: boolean;
  hasPendingEntry?: boolean;
  hasAlertEcItem?: boolean;
}) {
  const { data: sessionData = initialSessionData } = useSession();
  const [isMenuOpenedValue, setIsMenuOpened] = useIsMenuOpenedAtom();
  const [hereUrl, setHereUrl] = useState('');

  const showBadge = (session: Session) => {
    return session.user.unreadMessageBoxCount > 0 || isOptionNotEntered || hasPendingEntry || hasAlertEcItem;
  };

  useEffect(() => {
    setHereUrl(location.href);
  }, []);
  return (
    <header className={styles.componentStyle}>
      <div className={styles.container}>
        <div className={styles.dummy} />
        {sessionData ? (
          <div className={styles.menuWrapper} data-testid='user-banner'>
            <ToggleIconButton isActive={isMenuOpenedValue} onClick={() => setIsMenuOpened(!isMenuOpenedValue)} />
            {showBadge(sessionData) && (
              <div className={styles.menuBadge}>
                <Badge color='primary' />
              </div>
            )}
          </div>
        ) : (
          <div className={styles.auth}>
            <Link href={`/auth/signin?callbackUrl=${hereUrl}`} className={styles.loginLink} data-testid='login-link'>
              ログイン
            </Link>
            <div className={styles.signupButton}>
              <ActionButton
                color='primary'
                size='xSmall'
                onClick={() => {
                  location.href = `${process.env.NEXT_PUBLIC_MAIN_URL}/${process.env.NEXT_PUBLIC_SERVICE_ID}/auth/signup?callbackUrl=${hereUrl}`;
                }}
              >
                会員登録
              </ActionButton>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

export default FamikujiHeader;
